// src/source/geojsonvt.ts
var VectorSource = class {
  constructor(vector, x, y, z) {
    this.vectorLayerCache = {};
    this.x = x;
    this.y = y;
    this.z = z;
    this.vectorTile = vector;
  }
  getTileData(sourceLayer) {
    if (!sourceLayer || !this.vectorTile.layers[sourceLayer]) {
      return [];
    }
    if (this.vectorLayerCache[sourceLayer]) {
      return this.vectorLayerCache[sourceLayer];
    }
    const vectorTile = this.vectorTile.layers[sourceLayer];
    return vectorTile.features;
  }
  getFeatureById() {
    throw new Error("Method not implemented.");
  }
};
export {
  VectorSource as default
};
